import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchTimezone } from '../../../../components/FieldEngine/api/addressApi';
import { setTimezoneRequest, setTimezoneSuccess, setTimezoneFailure } from './timezoneSlice';

function* handleTimezoneRequest(action) {
  try {
    const { zip } = action.payload;
    const response = yield call(fetchTimezone, { zip });
    
    if (response && response.display_text) {
      yield put(setTimezoneSuccess({
        id: response.id,
        displayText: response.display_text,
      }));
    } else {
      yield put(setTimezoneFailure());
    }
  } catch (error) {
    console.error('[timezoneSaga] Failed to fetch timezone:', error);
    yield put(setTimezoneFailure());
  }
}

export default function* timezoneSaga() {
  yield takeLatest(setTimezoneRequest.type, handleTimezoneRequest);
}
